


































import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {Device, DeviceBusEventData, DeviceConfigurationSet} from "../../../types/core";
import Component from "vue-class-component";
import DownlinksQueueSection from "@/components/device/DownlinksQueueSection.vue";
import {curDeviceService} from "@/services/DeviceService";
import {DeviceCommandReq} from "@/services/CoreClient";
import _ from "lodash";

@Component({
  components: {
    DownlinksQueueSection,
  },
})
export default class RisingHfControl extends Vue {
  @Prop({ default: () => {}, type: Object}) device!:Device;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  private uplinkFreq:number = 900;
  private httpBusy:boolean = false;

  private error:string = '';

  created() {
    this.bus.$on('refresh-device', async (deviceBusEventData:DeviceBusEventData) => {
      await this.loadCurrentConfiguration();
    });
  }
  async mounted() {
    await this.loadCurrentConfiguration();
  }

  async updateUplinkFrequency() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'set_configuration',
        params: [{
          id: 1,
          value: this.uplinkFreq,
        }],
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout( () => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async loadCurrentConfiguration() {
    try {
      const reply = await curDeviceService.loadDeviceConfiguration({deviceId: this.device.deviceId}) as DeviceConfigurationSet;
      if (reply.newConf) {
        const freqParam = _.find(reply.newConf, (param) => param.id === 1);
        if (freqParam) {
          this.uplinkFreq = freqParam.value as number;
        }
      }
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  cancel() {
    this.$emit('close');
  }

  get canUpdateFrequency():boolean {
    return !this.httpBusy &&
        this.uplinkFreq % 2 === 0;
  }
}
